import React, { createContext } from 'react';
import { HomeProduct, ProductDetails } from '../../types/productTypes';

export type ProductContextProps = {
	productDetails: ProductDetails;
	getProducts: Function;
	getListProducts: Function;
	getFilterProducts: Function;
	productsData: Array<HomeProduct>;
	setProductsData: Function;
};

const ProductContext = createContext({} as ProductContextProps);

export default ProductContext;
